export var ID = '@to-be-rembursed';
export default {
    ID: ID,
    GET_CONFIG_LIST: ID + "/GET_CONFIG_LIST",
    SAVE_CONFIG_LIST: ID + "/SAVE_CONFIG_LIST",
    UPDATE_CONFIG_LIST: ID + "/UPDATE_CONFIG_LIST",
    SEND_RECONCILISTION: ID + "/SEND_RECONCILISTION",
};
